/* eslint-disable jsx-a11y/scope */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
const ES3RevisedUpdate = ({ ...props }) => {
    const [load, setload] = useState(true)
    const [formData, setFormData] = useState({
        EmploymentId: Number(props.employmentId),
        UserId: Number(localStorage.getItem("userId")),
        ParametersId: Number(props.parametersId),
        CategoryOfApplicantsTotalAllCategories3: 0,
        CategoryOfApplicantsTotalSc4: 0,
        CategoryOfApplicantsTotalSt5: 0,
        CategoryOfApplicantsTotalObc6: 0,
        CategoryOfApplicantsTotalPh7: 0,
        CategoryOfApplicantsTotalWomen8: 0,
        Transgender: 0,


    });


    const getdata = async () => {
        const sendData = {
            UserId: Number(localStorage.getItem("userId")),
            ParametersId: Number(props.parametersId),
            EmploymentId: Number(props.employmentId),
        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/GetEs3revisedDetails', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    const maindata = data[0]
                    //console.log(maindata)
                    setFormData({
                        CategoryOfApplicantsTotalAllCategories3: maindata.categoryOfApplicantsTotalAllCategories3,
                        CategoryOfApplicantsTotalSc4: maindata.categoryOfApplicantsTotalSc4,
                        CategoryOfApplicantsTotalSt5: maindata.categoryOfApplicantsTotalSt5,
                        CategoryOfApplicantsTotalObc6: maindata.categoryOfApplicantsTotalObc6,
                        CategoryOfApplicantsTotalPh7: maindata.categoryOfApplicantsTotalPh7,
                        CategoryOfApplicantsTotalWomen8: maindata.categoryOfApplicantsTotalWomen8,
                        Transgender: maindata.transgender,
                        UserId: Number(localStorage.getItem("userId")),
                        ParametersId: Number(props.parametersId),
                        EmploymentId: Number(props.employmentId),
                    });
                    setload(false)
                })


    };
    const onInputChange = async (e) => {
        e.target.value < 0 ? e.target.value = null : Number(e.target.value)
        setFormData({ ...formData, [e.target.name]: Number(e.target.value) });
        const sendData = {
            ...formData, [e.target.name]: Number(e.target.value)
        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/UpdateDetailsEs3revised', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                maindata => {
                    setFormData({
                        CategoryOfApplicantsTotalAllCategories3: maindata.categoryOfApplicantsTotalAllCategories3,
                        CategoryOfApplicantsTotalSc4: maindata.categoryOfApplicantsTotalSc4,
                        CategoryOfApplicantsTotalSt5: maindata.categoryOfApplicantsTotalSt5,
                        CategoryOfApplicantsTotalObc6: maindata.categoryOfApplicantsTotalObc6,
                        CategoryOfApplicantsTotalPh7: maindata.categoryOfApplicantsTotalPh7,
                        CategoryOfApplicantsTotalWomen8: maindata.categoryOfApplicantsTotalWomen8,
                        Transgender: maindata.transgender,
                        UserId: Number(localStorage.getItem("userId")),
                        ParametersId: Number(props.parametersId),
                        EmploymentId: Number(props.employmentId),
                    });
                    setload(false)
                })
        props.setGTotal(props.GTotal + 1)
    };






    useEffect(() => {
        getdata()

    }, [props.Change])


    const inputHandler = (e) => {
        const { value, maxLength } = e.target;
        if (String(value).length >= maxLength) {
            e.preventDefault();
            return;
        }
    };

    return (
        load ? null : <>
            {props.parentId === -1 ?
                <tr scope="row" >
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                        {props.sno}
                    </td>
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                        {props.name}
                    </td>
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                        {props.edit ? <input
                            type="number"
                            min="0"
                            id="CategoryOfApplicantsTotalAllCategories3"
                            className="form-control" maxLength="7" onKeyPress={inputHandler}
                            name="CategoryOfApplicantsTotalAllCategories3"
                            style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                            onChange={(e) => onInputChange(e)}
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            defaultValue={formData.CategoryOfApplicantsTotalAllCategories3}
                        /> : formData.CategoryOfApplicantsTotalAllCategories3}
                        {/*<label>{formData.CategoryOfApplicantsTotalAllCategories3} </label>*/}
                    </td>
                </tr> :
                <tr scope="row"  >
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                        {props.sno}

                    </td>

                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 250 }} >
                        {props.name}
                    </td>
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                        {props.edit ? <input
                            type="number"
                            min="0"
                            id="CategoryOfApplicantsTotalAllCategories3"
                            className="form-control" maxLength="7" onKeyPress={inputHandler}
                            name="CategoryOfApplicantsTotalAllCategories3"
                            style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                            onChange={(e) => onInputChange(e)}
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            defaultValue={formData.CategoryOfApplicantsTotalAllCategories3}
                        /> : formData.CategoryOfApplicantsTotalAllCategories3}
                        {/*<label>{formData.CategoryOfApplicantsTotalAllCategories3} </label>*/}
                    </td>
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                        {props.edit ? <input
                            type="number"
                            min="0"
                            id="CategoryOfApplicantsTotalSc4"
                            className="form-control" maxLength="7" onKeyPress={inputHandler}
                            name="CategoryOfApplicantsTotalSc4"
                            style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                            onChange={(e) => onInputChange(e)}
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            defaultValue={formData.CategoryOfApplicantsTotalSc4}
                        /> : formData.CategoryOfApplicantsTotalSc4}
                    </td>
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                        {props.edit ?
                            <input
                                type="number"
                                min="0"
                                id="CategoryOfApplicantsTotalSt5"
                                className="form-control" maxLength="7" onKeyPress={inputHandler}
                                name="CategoryOfApplicantsTotalSt5"
                                style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                                onChange={(e) => onInputChange(e)}
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                                defaultValue={formData.CategoryOfApplicantsTotalSt5}
                            /> : formData.CategoryOfApplicantsTotalSt5}
                    </td>
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                        {props.edit ? <input
                            type="number"
                            min="0"
                            id="CategoryOfApplicantsTotalObc6"
                            className="form-control" maxLength="7" onKeyPress={inputHandler}
                            name="CategoryOfApplicantsTotalObc6"
                            style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                            onChange={(e) => onInputChange(e)}
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            defaultValue={formData.CategoryOfApplicantsTotalObc6}
                        /> : formData.CategoryOfApplicantsTotalObc6}
                    </td>
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                        {props.edit ?
                            <input
                                type="number"
                                min="0"
                                id="CategoryOfApplicantsTotalPh7"
                                className="form-control" maxLength="7" onKeyPress={inputHandler}
                                name="CategoryOfApplicantsTotalPh7"
                                style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                                onChange={(e) => onInputChange(e)}
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                                defaultValue={formData.CategoryOfApplicantsTotalPh7}
                            /> : formData.CategoryOfApplicantsTotalPh7}
                    </td>
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                        {props.edit ?
                            <input
                                type="number"
                                min="0"
                                id="CategoryOfApplicantsTotalWomen8"
                                className="form-control" maxLength="7" onKeyPress={inputHandler}
                                name="CategoryOfApplicantsTotalWomen8"
                                style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                                onChange={(e) => onInputChange(e)}
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                                defaultValue={formData.CategoryOfApplicantsTotalWomen8}
                            /> : formData.CategoryOfApplicantsTotalWomen8}
                    </td>
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                        {props.edit ?
                            <input
                                type="number"
                                min="0"
                                id="transgender"
                                className="form-control" maxLength="7" onKeyPress={inputHandler}
                                name="transgender"
                                style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                                onChange={(e) => onInputChange(e)}
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                                defaultValue={formData.Transgender}
                            /> : formData.Transgender}
                    </td>
                </tr>
            }
        </>
    );
};

export default ES3RevisedUpdate;
